import { NfcCardOrdersPage, fetchCardOrders } from 'lib/models/nfcCards';
import { useCallback, useEffect, useState } from 'react';

const emptyPage: NfcCardOrdersPage = { elements: [], total: 0, failed: false };

function useNfcCardOrders(cardId: string, page: number, rowsPerPage: number) {
	const [loading, setLoading] = useState<boolean>(false);

	const [orders, setOrders] = useState<NfcCardOrdersPage>(emptyPage);

	const refetch = useCallback(async () => {
		setLoading(true);
		const response = await fetchCardOrders(cardId, page, rowsPerPage);
		setOrders(response);
		setLoading(false);
	}, [cardId, page, rowsPerPage]);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { loading, orders: orders.elements, total: orders.total, failed: orders.failed, refetch };
}

export default useNfcCardOrders;
